import React from 'react';
import { useTranslation } from 'react-i18next';

interface ReservationConditionsProps {
  conditions: string;
}

/**
 * Composant pour afficher les conditions de réservation du professionnel
 */
const ReservationConditions: React.FC<ReservationConditionsProps> = ({ conditions }) => {
  const { t } = useTranslation();

  // Si pas de conditions, afficher un message par défaut
  if (!conditions || conditions.trim() === '') {
    return null;
  }

  return (
    <div className="mt-4 mx-auto max-w-2xl p-4 bg-white/80 backdrop-blur-sm rounded-lg border border-gray-200 shadow-sm">
      <h3 className="text-base font-semibold text-gray-800 mb-2 text-center">
        {t('booking.reservationConditionsTitle')}
      </h3>
      <div className="text-sm text-gray-600 whitespace-pre-wrap">
        {conditions}
      </div>
    </div>
  );
};

export default ReservationConditions;
